.panel {
  background-color: var(--mantine-color-gray-0);
  border-left: 3px solid var(--mantine-color-blue-5);
}

[data-mantine-color-scheme='dark'] .panel {
  background-color: var(--mantine-color-dark-6);
}

.header {
  padding-bottom: var(--mantine-spacing-xs);
  border-bottom: 1px solid var(--mantine-color-gray-2);
}

[data-mantine-color-scheme='dark'] .header {
  border-bottom-color: var(--mantine-color-dark-4);
}

.scrollArea {
  margin-top: var(--mantine-spacing-xs);
}

.fieldLabel {
  margin-bottom: calc(var(--mantine-spacing-md) * 0.125);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.fieldValue {
  word-break: break-word;
}

.actions {
  padding-top: var(--mantine-spacing-md);
  border-top: 1px solid var(--mantine-color-gray-2);
}

[data-mantine-color-scheme='dark'] .actions {
  border-top-color: var(--mantine-color-dark-4);
}
